(function () {
  var script = document.querySelector('script[src*="rsg-intercom-identity.js"]');
  var identify = script && script.hasAttribute('data-rsg-intercom-identity');

  function whenReady(done) {
    if (typeof window.Intercom === 'function') {
      done();
      return;
    }
    var tries = 0;
    var timer = window.setInterval(function () {
      tries += 1;
      if (typeof window.Intercom === 'function' || tries > 40) {
        window.clearInterval(timer);
        if (typeof window.Intercom === 'function') done();
      }
    }, 250);
  }

  function isLogoutLink(node) {
    if (!node || !node.getAttribute) return false;
    var href = node.getAttribute('href') || '';
    var action = node.getAttribute('action') || '';
    return href.indexOf('/account/logout') !== -1 || action.indexOf('/account/logout') !== -1;
  }

  document.addEventListener('click', function (event) {
    var node = event.target && event.target.closest ? event.target.closest('a, button') : null;
    if (!isLogoutLink(node) || typeof window.Intercom !== 'function') return;
    window.Intercom('shutdown');
  }, true);

  document.addEventListener('submit', function (event) {
    if (!isLogoutLink(event.target) || typeof window.Intercom !== 'function') return;
    window.Intercom('shutdown');
  }, true);

  if (!identify) return;

  fetch('/apps/rsg-intercom/jwt', { credentials: 'same-origin' })
    .then(function (response) {
      if (!response.ok) return null;
      return response.json();
    })
    .then(function (body) {
      if (!body || !body.token) return;
      whenReady(function () {
        window.Intercom('update', {
          intercom_user_jwt: body.token,
          user_id: body.user_id,
          email: body.email,
          name: body.name,
          created_at: body.created_at
        });
      });
    })
    .catch(function () {});
})();
